import { useEffect, useState } from "react"
import { SquareArrowOutUpRight } from 'lucide-react';
import Popover from "./Popover"
import { usePopoverState } from "../hooks/usePopoverState"
import { CUBES_MODULE_INFO } from "../data/cubes"

/**
 * Compute a horizontal offset that points the arrow towards
 * the target cube position relative to the popover's horizontal center.
 */
function useArrowOffset(displayedCubePosition, containerRef) {
  const [arrowOffset, setArrowOffset] = useState(0);

  useEffect(() => {
    if (!displayedCubePosition || !containerRef.current) {
      setArrowOffset(0);
      return;
    }

    const popoverRect = containerRef.current.getBoundingClientRect();
    const popoverCenterX = popoverRect.left + popoverRect.width / 2;
    const cubeX = displayedCubePosition.x;

    // Calculate horizontal offset from popover center to cube center
    setArrowOffset(cubeX - popoverCenterX);
  }, [displayedCubePosition, containerRef]);

  return arrowOffset;
}

export default function CubePopover({ infoKey, cubePosition, anchorName, onClose, showLink = false }) {
  const {
    displayedKey,
    isClosing,
    handleClose,
    displayedPosition,
    anchor,
    containerRef,
  } = usePopoverState({
    itemKey: infoKey,
    itemPosition: cubePosition,
    anchorName,
    defaultAnchor: "--cube-0-0",
    ignoreSelector: "[data-cube-wrapper]",
    onClose,
  });

  const arrowOffset = useArrowOffset(displayedPosition, containerRef);

  if (!displayedKey) return null;
  const info = CUBES_MODULE_INFO[displayedKey];
  if (!info) return null;

  return (
    <Popover
      isClosing={isClosing}
      onClose={handleClose}
      title={info.title}
      anchor={anchor}
      positionArea="top"
      arrowPosition="bottom"
      arrowOffset={arrowOffset}
      variant="cube"
      containerRef={containerRef}
    >
      <div className="popover-field">
        <strong>Modulname:</strong> {info.short_title || info.title}
      </div>

      <div className="popover-field">
        <strong>Namenskürzel:</strong> {info.abbreviation}
      </div>

      <hr className="popover-divider" />

      <p className="popover-description">{info.description}</p>

      {showLink && (
        <button type="button" className="popover-link link-style" onClick={(e) => e.preventDefault()}>
          Mehr Erfahren
          <span>
            <SquareArrowOutUpRight size={18} />
          </span>
        </button>
      )}
    </Popover>
  );
}
